export const datesMatch = (first, second) => {
  if (!first || !second) return first === second;
  const firstTime = new Date(first).getTime();
  const secondTime = new Date(second).getTime();
  if (Number.isNaN(firstTime) || Number.isNaN(secondTime)) return first === second;
  return firstTime === secondTime;
};

export const shouldUpdateLinkedDate = (currentValue, previousSourceValue) => (
  !currentValue || datesMatch(currentValue, previousSourceValue)
);
